module.exports = __webpack_public_path__ + "img/step1.9ef80627.svg";